import React, { FunctionComponent } from "react";
import styled from "styled-components/macro";

export const ErrorMessageLightMode = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorMessage = styled.div`
  display: flex;
  color: #5d4504;
  background-color: #ffe38a;
  border-color: #fddd79;
  align-items: center;
  justify-content: center;
`;

type ErrorAlertProps = {
  lightMode?: boolean;
};

const ErrorAlert: FunctionComponent<ErrorAlertProps> = props => {
  const { lightMode, children } = props;

  return (
    <>
      {lightMode ? (
        <ErrorMessageLightMode className="alert alert-warning" role="alert">
          {children}
        </ErrorMessageLightMode>
      ) : (
        <ErrorMessage className="alert alert-warning" role="alert">
          {children}
        </ErrorMessage>
      )}
    </>
  );
};

ErrorAlert.defaultProps = {
  lightMode: false
};

export default ErrorAlert;
